// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"c89405ee","232":"34e0b2dd","248":"45fed92a","323":"67ecc83c","340":"da7d2eef","799":"107fcf98"}[chunkId] + ".chunk.js";
};